import { AddressInputAddress } from 'lib/components/Form/AddressInput/AddressInput'

export const autoCompleteInputRules = (
  origin: AddressInputAddress | null,
  destination: AddressInputAddress | null,
) => {
  const validateZip = () =>
    !origin?.zip ||
    !destination?.zip ||
    origin?.zip !== destination?.zip ||
    'Origin and destination cannot be the same'

  return {
    required: {
      value: true,
      message: 'Please provide a location.',
    },
    validate: { validateZip },
  }
}
